import {SubjectSettingData} from '../../../types';

export const primitiveKeys: (keyof SubjectSettingData)[] = [
	'subjectName',
	'retestSubjectType',
	'isShuffleQuestions',
	'isPublishForTeacherActive',
	'isPublishForSpecialistsActive',
];
